/* Meliusly FAQ accordion + category tab filter. Vanilla JS, no deps. */
(function () {
  'use strict';

  function initAccordion(root) {
    var items = root.querySelectorAll('[data-mel-faq-item]');
    items.forEach(function (item) {
      var trigger = item.querySelector('[data-mel-faq-trigger]');
      var panel = item.querySelector('[data-mel-faq-panel]');
      var chevron = item.querySelector('[data-mel-faq-chevron]');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          panel.style.maxHeight = '0px';
          panel.classList.add('max-h-0');
          trigger.setAttribute('aria-expanded', 'false');
          if (chevron) chevron.classList.remove('rotate-180');
        } else {
          panel.classList.remove('max-h-0');
          panel.style.maxHeight = panel.scrollHeight + 'px';
          trigger.setAttribute('aria-expanded', 'true');
          if (chevron) chevron.classList.add('rotate-180');
        }
      });
    });
  }

  function initTabs(root) {
    var tabWrap = root.querySelector('[data-mel-faq-tabs]');
    if (!tabWrap) return;
    var tabs = tabWrap.querySelectorAll('[data-mel-faq-tab]');
    var items = root.querySelectorAll('[data-mel-faq-item]');

    function activate(category) {
      tabs.forEach(function (tab) {
        var active = tab.getAttribute('data-category') === category;
        tab.setAttribute('aria-pressed', active ? 'true' : 'false');
        tab.classList.toggle('bg-[#0268A0]', active);
        tab.classList.toggle('text-white', active);
        tab.classList.toggle('bg-gray-100', !active);
        tab.classList.toggle('text-gray-600', !active);
      });
      items.forEach(function (item) {
        var match = item.getAttribute('data-category') === category;
        item.style.display = match ? '' : 'none';
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-category'));
      });
    });

    var firstTab = tabs[0];
    if (firstTab) activate(firstTab.getAttribute('data-category'));
  }

  document.querySelectorAll('[data-mel-faq-list]').forEach(function (list) {
    var section = list.closest('section');
    if (!section) return;
    initAccordion(section);
    initTabs(section);
  });
})();
